import React from 'react';

const LogicGuide = ({ isHidden, onToggle }) => {
  if (isHidden) {
    return (
      <button className="aud-v2-guide-toggle" onClick={onToggle} type="button">
        <span className="material-icons">info</span>
        <span className="aud-v2-guide-toggle__text">Logic Guide</span>
        <span className="material-icons aud-v2-guide-toggle__expand">expand_more</span>
      </button>
    );
  }

  return (
    <div className="aud-v2-guide">
      <div className="aud-v2-guide__header">
        <div className="aud-v2-guide__header-left">
          <span className="material-icons">info</span>
          <h3>Logic Guide</h3>
        </div>
        <button className="aud-v2-guide__hide" onClick={onToggle} type="button">
          Hide
        </button>
      </div>
      <div className="aud-v2-guide__content">
        <div className="aud-v2-guide__section">
          <p className="aud-v2-guide__title">Within a Set (OR):</p>
          <p className="aud-v2-guide__text">
            Rules grouped inside a card use{' '}
            <span className="aud-v2-guide__code">OR</span> logic. A user only
            needs to match one rule to satisfy the set.
          </p>
        </div>
        <div className="aud-v2-guide__section">
          <p className="aud-v2-guide__title">Between Sets (AND):</p>
          <p className="aud-v2-guide__text">
            Multiple cards are joined by{' '}
            <span className="aud-v2-guide__code">AND</span> logic. A user must
            satisfy at least one rule in EVERY set.
          </p>
        </div>
        <div className="aud-v2-guide__section aud-v2-guide__section--border">
          <p className="aud-v2-guide__title">Exclusions:</p>
          <p className="aud-v2-guide__text">
            Any user matching an exclusion set will be removed from the final
            list, regardless of inclusion matches.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LogicGuide;
